import { body2, palette } from '@/modules/defines/styles';
import { styled } from 'styled-components';
import cancel from '@/assets/icon/circle-x-filled.webp';

const Input = styled.input<{
  $fontWeight?: number;
  $extraPadding?: string;
}>`
  padding: ${({ $extraPadding }) => $extraPadding || '0.62rem 1.25rem'};
  border-radius: 0.5rem;
  width: 100%;
  border: none;
  ${body2};
  font-weight: ${({ $fontWeight }) => $fontWeight || 700};
  color: ${palette.primaryBlack950};

  &::placeholder {
    color: ${palette.gray300};
  }
  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    height: 1.5rem;
    width: 1.5rem;
    background: url(${cancel}) no-repeat center;
    background-size: cover;
    cursor: pointer;
  }
`;

export default Input;
